/* Backwoodz808 theme — core interactions */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initCartDrawer();
    initQuickAdd();
    initVariantPicker();
  });

  function initVariantPicker() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;

    var optionGroups = form.querySelectorAll('[data-option-index]');
    if (!optionGroups.length) return;

    optionGroups.forEach(function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-option-value]');
        if (!btn) return;
        group.querySelectorAll('.option-pill').forEach(function (p) { p.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        updateSelectedVariant();
      });
    });

    function getSelectedOptions() {
      var selections = [];
      optionGroups.forEach(function (group) {
        var selected = group.querySelector('.is-selected');
        selections.push(selected ? selected.getAttribute('data-option-value') : null);
      });
      return selections;
    }

    function updateSelectedVariant() {
      if (!window.__productVariants) return;
      var selections = getSelectedOptions();
      var match = window.__productVariants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selections[i]; });
      });

      var input = form.querySelector('[data-variant-id-input]');
      var submitBtn = form.querySelector('[data-add-to-cart-btn]');
      if (!match) {
        if (submitBtn) {
          submitBtn.setAttribute('disabled', '');
          submitBtn.textContent = 'Unavailable';
        }
        return;
      }

      if (input) input.value = match.id;
      if (submitBtn) {
        if (match.available) {
          submitBtn.removeAttribute('disabled');
          submitBtn.textContent = 'Add to bag — ' + formatMoney(match.price);
        } else {
          submitBtn.setAttribute('disabled', '');
          submitBtn.textContent = 'Sold out';
        }
      }
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function initMobileNav() {
    var toggle = document.querySelector('[data-mobile-nav-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function () {
      var isOpen = !nav.hasAttribute('hidden');
      if (isOpen) {
        nav.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        nav.removeAttribute('hidden');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  }

  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    var overlay = document.querySelector('[data-cart-overlay]');
    var openBtns = document.querySelectorAll('[data-cart-toggle]');
    var closeBtn = document.querySelector('[data-cart-close]');
    if (!drawer || !overlay) return;

    function open() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
    }
    function close() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    }

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', open);
    });
    if (closeBtn) closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    window.Backwoodz808Cart = { open: open, close: close, refresh: refreshCartDrawer };
  }

  function initQuickAdd() {
    document.querySelectorAll('[data-quick-add]').forEach(function (el) {
      el.addEventListener('click', handleQuickAdd);
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleQuickAdd.call(el);
        }
      });
    });
  }

  function handleQuickAdd() {
    var variantId = this.getAttribute('data-variant-id');
    var productUrl = this.getAttribute('data-product-url');

    // Only true one-click add when the product has a single variant
    // (e.g. a one-size hat). Sized apparel needs the product page
    // so the customer picks a size — never guess that.
    if (variantId) {
      addVariantToCart(variantId);
    } else if (productUrl) {
      window.location.href = productUrl;
    }
  }

  function addVariantToCart(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(function () {
        refreshCartDrawer();
        if (window.Backwoodz808Cart) window.Backwoodz808Cart.open();
      })
      .catch(function (err) {
        console.error(err);
      });
  }

  function refreshCartDrawer() {
    fetch('/cart?view=drawer')
      .then(function (res) {
        if (!res.ok) throw new Error('Cart refresh failed');
        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('[data-cart-drawer]');
        var current = document.querySelector('[data-cart-drawer]');
        if (newDrawer && current) {
          current.innerHTML = newDrawer.innerHTML;
          initCartDrawerCloseBinding();
        }
        var countEl = document.querySelector('[data-cart-count]');
        var newCount = doc.querySelector('[data-cart-count]');
        if (countEl && newCount) countEl.textContent = newCount.textContent;
      })
      .catch(function (err) {
        console.error(err);
      });
  }

  function initCartDrawerCloseBinding() {
    var closeBtn = document.querySelector('[data-cart-close]');
    if (closeBtn && window.Backwoodz808Cart) {
      closeBtn.addEventListener('click', window.Backwoodz808Cart.close);
    }
  }
})();
